import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';

export const LearnMoreAboutEnvironments: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Policies', field: 'policies' },
    { label: 'Blueprints', field: 'blueprints' },
    { label: 'Ticketing', field: 'ticketing' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="environments"
      headerTitle="Environments"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Overview</Text>
            <Text>
              Environments provide a way for you to group accounts to reflect
              business structure or boundaries – like say production,
              development, staging or by business units or by cost allocation.
              Environments are also the unit of policy management using policy
              blueprints. Policy blueprints, which comprise individual policies,
              are applied to environments, so that findings and issues are
              organized accordingly. Environments allow you to enforce policies
              in a highly customized way, so that policies in say production can
              be different and significantly more stringent than say
              development. Similarly, you can enforce policies based on business
              needs of business units.
            </Text>
          </Stack>
          <Stack>
            <Text fontWeight={600}>Policy and Lifecycle Management</Text>
            <Text pb={2}>
              <LearnMoreInlineLink
                label="Policy blueprints"
                field="blueprints"
                value
              />{' '}
              that are applied in each environment provide complete and isolated
              lifecycle management for policies and resources in that
              environment. You can add, update, delete or apply exceptions
              within a policy blueprint that applies to an environment
              independent of any other policy blueprints that apply to the same
              environment.
            </Text>
            <Text>
              You can apply multiple policy blueprints to a single environment –
              especially when policy management is distributed and a shared, but
              collective responsibility among multiple stakeholders.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
